<script>
  import { isEnglish, setIsEnglish } from "../stores/cookies.js";
  import BottomCard from "../components/BottomCard.svelte";
  import StaffCardMajor from "../components/StaffCardMajor.svelte";
  import Popup from "../components/Popup.svelte";
  import StaffCardMinor from "../components/StaffCardMinor.svelte";
  import AppBar from "../components/AppBar.svelte";

  let showPopup = false;
  let popupData = {
    title: "",
    description: "",
    imageSrc: "",
  };

  $: popupData; // ← makes it reactive if you ever want derived behavior later

  function openPopup(item) {
    popupData = { ...item };
    showPopup = true;
  }

  function closePopup() {
    showPopup = false;
  }
</script>

<AppBar />

<main class="p-4 mx-auto space-y-6">
  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Our Team" : "Ons Span"}
  </h1>

  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Our Veterinarians" : "Ons Veeartse"}
  </h1>

  <div class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32">
    <div
      class="
    grid
    grid-cols-1
    md:grid-cols-2
    gap-6 md:gap-8 lg:gap-10 xl:gap-12
    auto-cols-min
    [grid-template-columns:repeat(auto-fit,minmax(320px,1fr))]
    md:[grid-template-columns:repeat(auto-fit,minmax(600px,1fr))]
  "
    >
      <!-- 16px padding on all sides -->
      <StaffCardMajor
        imageSrc="assets/headshots/anelFull.jpeg"
        title="Dr. Anel van der Merwe"
        description={$isEnglish
          ? "Dr. Anel is one of our resident veterinarians at Vredenburg Veterinary Animal hospital. See link to learn more about her."
          : "Dr. Anel is 'n voltydse veearts by Vredenburg Dierehospitaal. Sien die skakel om meer oor haar te wete te kom."}
        href="#/team/john-smith"
        alt="Dr. Anel van der Merwe"
        onClick={() =>
          openPopup({
            title: "Dr Anel van der Merwe",
            description: $isEnglish
              ? "Dr. Anel graduated from the Universiy of Pretoria in Veterinary Science in 2009. She also holds a degree from the University of Pretoria in Veterinary Biology in which she graduated in 2004. Originally from the Freestate, Dr. Anel started working in the Cape Town area at various practices including Kuilsrivier. She moved to the West Coast in 2011 where she started working for Weskus Veeartseny.\n\nDr Anel's interests lie in small animals. Particularly in surgery and diagnostic imaging. Dr. Anel is passionate about animal wellbeing and enjoys working with animal welfare organisations.\n\nDr Anel is a resident of Vredenburg and enjoy's going to the beach with her family, visiting the surrounding beautifull towns of the West Coast. She also loves the flower season during August/September."
              : "Dr. Anel het gegraduaeer te Universiteit van Pretoria in Veeartsenykunde in 2009. Sy het ook 'n graad behaal vanaf die Universiteit van Pretoria in Veterinere Biologie in 2004. Dr. Anel het groot geword in die Vrystaat en het begin werk in die Kaapstad area by verskillende praktyke insluitende Kuilsrivier. Sy het na die Weskus verhuis in 2011 waar sy begin werk het by Weskus Veeartseny.\n\nDr. Anel se belangstellings lê in klein diere. Sy stel veral belang in chirurgie en radiografistiese diagnose. Dr. Anel is passievol oor welsynswerk met diere en geniet dit om saam met welsynsorganisasies te werk.\n\nDr. Anel is 'n voltydse veearts by Vredenburg Dierehospitaal, sy geniet dit om strand toe te gaan saam met haar familie en om die omliggende dorpe van die Weskus te besoek. Sy is ook baie lief vir die blommetjie seisoen in die Weskus gedurende Augustus en September.",
            imageSrc: "assets/headshots/AnelFull.jpg",
          })}
      />

      <StaffCardMajor
        imageSrc="assets/headshots/LucindaFull.jpg"
        title="Dr. Lucinda Cowan"
        description={$isEnglish
          ? "Dr. Lucinda is one of our resident veterinarians at Langebaan Veterinary Animal hospital. See link to learn more about her."
          : "Dr. Lucinda is ons ander voltydse veearts by Langebaan Dierehospitaal. Sien die skakel om meer oor haar te wete te kom."}
        href="#/team/lucinda-cowan"
        alt="Dr. Lucinda Cowan"
        onClick={() =>
          openPopup({
            title: "Dr. Lucinda Cowan",
            description: $isEnglish
              ? "Dr. Lucinda graduated from the Universiy of Pretoria in Veterinary Science in 2017. She hails from Johannesburg. During her CCS year (Compulsory Community Service) in the Transkei, she gained value experience working with production animals, small animals and the occasional injured game.\n\nDr. Lucinda is currently practising full-time at the Langebaan branch of the Vredenburg Veterinary Hospital group. Dr Lucinda has a love for small animals, but would really like to own a pet cow.\n\nDr Lucinda enjoys the laid back atmosphere of the Westcoast looks forward to exploring more of the West Coast. She also loves the ocean and following the annual Sardine run is one of her hobbies. In her spare time she enjoys baking."
              : "Dr. Lucinda het gegradueer te die Universiteit van Pretoria in 2017. Dr. Lucinda het in Johannesburg groot geword. Tydens haar CCS jaar (Compulsory Community Service), in die Transkei, het sy waardevolle ervaring opgedoen met grootdiere, kleindiere en soms beseerde wild.\n\nDr. Lucinda is tans voltyds by die Langebaan tak van die Vredenburg Dierehospitaal groep. Dr Lucinda het 'n voorliefde vir klein diere, maar wil bittergraag ‘n troetel koei hê.\n\nDr Lucinda geniet die rustigheid van die Weskus en sien uit daarna om nog die hele Weskus te verken. Sy is ook baie lief vir die see en om die jaarlikse Sardine Run te volg is een van haar stokperdjies. In haar vrye tyd geniet sy dit om te bak.",
            imageSrc: "assets/headshots/LucindaFull2.png",
          })}
      />

      <StaffCardMajor
        imageSrc="assets/headshots/MarthinusFull.jpeg"
        title="Dr. Marthinus Jacobs"
        description={$isEnglish
          ? "Dr. Marthinus is responsible for the Animal Clinic in Velddrif, whereafter he completes a couple of farm rounds before consulting in Vredenburg. See link to learn more about him."
          : "Dr. Marthinus is verantwoordelik vir die Velddrif Dierekliniek waarna hy grootdierrondtes afhandel voordat hy in die middae sy dag op Vredenburg afsluit. Sien die skakel om meer oor hom te wete te kom."}
        href="#/team/marthinus-jacobs"
        alt="Dr. Marthinus Jacobs"
        onClick={() =>
          openPopup({
            title: "Dr. Marthinus Jacobs",
            description: $isEnglish
              ? "Dr. Marthinus Jacobs grew up in Johannesburg, qualifying as a Veterinarian from the University of Pretoria in 2017. He completes his Community Service year, stationed in Kimberley but servicing the whole expanse of the Northern Cape, from Askham to Williston and beyond, treating as wide a variety of species.\n\nNot keen on moving back to the Big City and a love for countryside production animal work, he joins the team at Weskus Veeartseny in 2019.\n\nCurrently Dr. Marthinus is responsible for the Animal Clinic in Velddrif, whereafter he completes a couple of farm rounds before consulting in Vredenburg. He enjoys soft tissue surgery, dentistry and has a developing interest in equine internal medicine.\n\nIn his spare time, he enjoys driving the most obscure dirt roads he can find, exploring old farmstead ruins, watches birds, drinks wine and collects interesting plants. Dr. Jacobs also has an unusual interest in honeybee health and diseases."
              : "Dr. Marthinus Jacobs het in Johannebsurg grootgeword en kwalifiseer as veearts aan die Universiteit van Pretoria in 2017. Hy voltooi sy gemeenskapsdiensjaar gestasioneer op Kimberley maar werk kruis en dwars oor die uitgestrekte landskap van die Noord Kaap van Askham tot Williston met net so ‘n groot verskeidenheid van dierespesies.\n\nMet die Grootstad wat hom nie weer sien nie en ‘n voorliefde vir plattelandse produksiedierwerk sluit hy in 2019 by die Vredenburg Dierehospitaalspan aan.\n\nTans is Dr. Marthinus verantwoordelik vir die Velddrif Dierekliniek waarna hy grootdierrondtes afhandel voordat hy in die middae sy dag op Vredenburg afsluit. Hy geniet sagteweefsel sjirurgie en tandheelkunde en het ‘n ontwikkelde belangstelling in perdegeneeskunde.\n\nIn sy vryetyd ry hy die kleinste grondpaadjies wat hy kan kry, krap in murasies rond, kyk voëls, drink wyn en versamel interessante plante. Dr. Marthinus het ook ‘n buitengewone blelangstelling in byegesondheid en -siektes.",
            imageSrc: "assets/headshots/MarthinusFull2.png",
          })}
      />

      <StaffCardMajor
        imageSrc="assets/headshots/MarnusHead.png"
        title="Dr. Marnus Jansen van Rensburg"
        description={$isEnglish
          ? "Dr. Marnus joined Weskus Veeartseny in 2025 and is one of our veterinarians at Langebaan Animal Hospital. Click the link to learn more about him."
          : "Dr. Marnus het in 2025 by Weskus Veeartseny aangesluit en is een van ons veeartse by die Langebaan Dierehospitaal. Klik op die skakel om meer oor hom uit te vind."}
        href="#/team/marnus-jansen-van-rensburg"
        alt="Dr. Marnus Jansen van Rensburg"
        onClick={() =>
          openPopup({
            title: "Dr. Marnus Jansen van Rensburg",
            description: $isEnglish
              ? "Dr. Marnus Jansen van Rensburg completed his degree at the University of Namibia in 2020, after which he worked in the private sector in Pretoria. He then successfully completed the SAVC board exams and completed his Compulsory Community Service year in the Northwest. His hobbies are spending time with his young family, playing cricket, tennis and angling. He is part of the Langebaan Shore Angling Club. He is passionate about nature conservation.\n\nHis interests are in Small Animals, Production Animals, Equines and Wildlife Medicine and Management."
              : "Dr. Marnus Jansen van Rensburg het sy graad in 2020 aan die Universiteit van Namibië voltooi, waarna hy in die privaatsektor in Pretoria gewerk het. Hy het daarna die SAVC-raads­eksamens suksesvol geslaag en sy jaar van Verpligte Gemeenskapsdiens in die Noordwes voltooi. Sy stokperdjies sluit in om tyd saam met sy jong gesin deur te bring, asook om krieket en tennis te speel en te hengel. Hy is deel van die Langebaan Shore Angling Club. Hy is passievol oor natuurbewaring.\n\nSy belangstellings lê in kleindiere, produksiediere, perde en wildgeneeskunde en -bestuur.",
            imageSrc: "assets/headshots/MarnusFull.png",
          })}
      />
    </div>
  </div>

  <div class="w-full h-[2px] bg-blue-600 my-10"></div>

  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Our Support Staff" : "Ons Ondersteunings Personeel"}
  </h1>

  <div class="py-8 md:py-12 px-6 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32">
    <div
      class="
    grid
    gap-6 md:gap-8 lg:gap-10 xl:gap-12
    grid-cols-[repeat(auto-fit,minmax(190px,1fr))]
    justify-items-center
  "
    >
      <StaffCardMinor
        imageSrc="assets/headshots/Luzaan1.jpeg"
        title="Luzaan"
        description={$isEnglish
          ? "Animal Health Technician/Practice Manager"
          : "Veterinere Tegnikus/Praktyk Bestuurder"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Madeleine2.jpeg"
        title="Madelein"
        description={$isEnglish
          ? "Accounts/Administration"
          : "Rekeninge/Administrasie"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Kaylee.png"
        title="Kayley"
        description={$isEnglish ? "Hospital Assistant" : "Hospitaal Assistent"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Rene.png"
        title="Rene"
        description={$isEnglish ? "Hospital Assistant" : "Hospitaal Assistent"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Larishka2.jpeg"
        title="Larishka"
        description={$isEnglish
          ? "Reception (Vredenburg)"
          : "Ontvangs (Vredenburg)"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Bianca.png"
        title="Bianca"
        description={$isEnglish
          ? "Reception (Vredenburg)"
          : "Ontvangs (Vredenburg)"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Anja2.jpeg"
        title="Anja"
        description={$isEnglish
          ? "Reception (Langebaan)"
          : "Ontvangs (Langebaan)"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Michelle.png"
        title="Michelle"
        description={$isEnglish
          ? "Reception (Langebaan)"
          : "Ontvangs (Langebaan)"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Roslyn.png"
        title="Roslyn"
        description={$isEnglish
          ? "Reception (Velddrif Animal Clinic)"
          : "Ontvangs (Velddrif Dierekliniek)"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/akanaloHead.jpg"
        title="Akanalo"
        description={$isEnglish ? "Kennel Hand" : "Diereversorger"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Victor1.jpeg"
        title="Victor"
        description={$isEnglish ? "Kennel Hand" : "Diereversorger"}
      />

      <StaffCardMinor
        imageSrc="assets/headshots/Obvious1.jpeg"
        title="Obvious"
        description={$isEnglish ? "Kennel Hand" : "Diereversorger"}
      />
    </div>
  </div>

  <div class="w-full h-[2px] bg-blue-600 my-10"></div>

  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Our Practice" : "Ons Praktyk"}
  </h1>

  <p
    class="text-gray-900 text-base md:text-lg leading-relaxed group-hover:text-blue-600 text-center md:text-left
    text-blue-900
    text-1xl sm:text-1xl md:text-1xl lg:text-2xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    whitespace-pre-line"
  >
    {$isEnglish
      ? "Weskus Veeartseny consists of one practice at six seperate locations. Our two main veterinary hospitals are located in Vredenbug and Langebaan, but we also have satelite clinics in Saldanha, Hopefield, St Helena Bay and Velddrif. Our various operating and consultation hours and the locations of each of our clinics is available at the bottom of the page.\n\nWeskus Veeartseny has been in practice in the West Coast since March 1969. The practice moved to their current Vredenburg premises in Deur Road in 1985.\n\nWeskus Veeartseny is a mixed practice. We are the oldest practice in the area, and we are rooted in the west coast. We are committed to serving both the west coast towns and farming community."
      : "Weskus Veeartseny bestaan uit een praktyk met ses verskillende liggings. Ons twee hoof dierehospitale is in Vredenburg en Langebaan geleë, en ons het ook satellietklinieke in Saldanha, Hopefield, St Helena Baai en Velddrif. Ons verskillende spreekure, konsultasie-ure en die liggings van elkeen van ons klinieke is onderaan die blad beskikbaar.\n\nWeskus Veeartseny praktiseer reeds sedert Maart 1969 in die Weskus. Die praktyk het in 1985 na hul huidige Vredenburg perseel in Deurweg verhuis.\n\nWeskus Veeartseny is ’n gemengde praktyk. Ons is die oudste praktyk in die area en diep gewortel in die Weskus. Ons is verbind daartoe om beide die dorpsgemeenskappe en die landbougemeenskap van die Weskus te dien."}
  </p>

  <h1
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  >
    {$isEnglish ? "Our Mission" : "Ons Missie"}
  </h1>

  <p
    class="text-gray-900 text-base md:text-lg leading-relaxed group-hover:text-blue-600 text-center md:text-left
    text-blue-900
    text-1xl sm:text-1xl md:text-1xl lg:text-2xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    whitespace-pre-line"
  >
    {$isEnglish
      ? "We are committed to serving West Coast towns and farming communities. Our mission is to provide a wide range of high quality veterinary care at reasonable cost.\n\nWe further aim to provide these serves to the West Coast area community in order for them to not have to travel to Cape Town to receive high quality veterinary care, but have it available on their doorsteps."
      : "Ons het onsself toegewy om die Weskus dorpe en plaas gemeenskappe te bedien. Ons missie is om 'n wye verskeidenheid hoë kwaliteit veeartseny dienste teen billike pryse te bied. Verder streef ons daarna om al hierdie dienste aan die Weskus gemeenskap te bied sodat dit nie nodig is om Kaapstad toe te gaan vir hoë kwaliteit veeartseny sorg nie, maar dat dit maklik beskikbaar is op hulle voorstoepe."}
  </p>

  <div
    class="
    text-center md:text-left
    text-blue-900 font-bold
    text-2xl sm:text-3xl md:text-4xl lg:text-5xl
    tracking-tight
    pl-6 sm:pl-8 md:pl-12 lg:pl-16 xl:pl-24 2xl:pl-32
    pt-0 sm:pt-2 md:pt-4 lg:pt-6 xl:pt-8 2xl:pt-10
  "
  ></div>

  <BottomCard />
</main>

<Popup
  open={showPopup}
  title={popupData.title}
  description={popupData.description}
  imageSrc={popupData.imageSrc}
  alt="Staff member photo"
  onClose={closePopup}
/>
